// store/adminConfig.reducer.js
import * as types from './actionTypes';

const INITIAL_STATE = {
  // Data
  dashboard: null,
  colleges: [],
  smes: [],
  courses: [],
  degrees: [],
   collegeDegrees: [],
  categories: [],
  mappings: {
    collegeCourses: [],
    smeCourses: [],
    degreeCourses: [],
    courseCategories: [],
    collegeDegreeMappings: [], // NEW: Added under mappings
  },
  
  // Pagination
  pagination: {
    collegeCourses: { page: 1, limit: 20, total: 0, totalPages: 0 },
    smeCourses: { page: 1, limit: 20, total: 0, totalPages: 0 },
    degreeCourses: { page: 1, limit: 20, total: 0, totalPages: 0 },
    courseCategories: { page: 1, limit: 20, total: 0, totalPages: 0 },
    collegeDegreeMappings: { page: 1, limit: 20, total: 0, totalPages: 0, hasNext: false, hasPrev: false }, // NEW
  },
  
  // UI State
  loading: false,
  error: null,
  
  // Operation States
  operations: {
    creating: false,
    updating: false,
    deleting: false,
    createError: null,
    updateError: null,
    deleteError: null,
    
    // NEW: College Degree Mapping Operations
    fetchingCollegeDegreeMappings: false,
    creatingCollegeDegreeMapping: false,
    updatingCollegeDegreeMapping: false,
    deletingCollegeDegreeMapping: false,
    collegeDegreeMappingError: null,
    
    // Semester Promotion Operations
    promotingSemester: false,
    promotionResult: null,
    promotionError: null,
    previewingSemester: false,
    semesterPreview: null,
    previewError: null
  }
};

const adminConfigReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // ================================INITIAL DATA FETCH ================================ //
    case types.FETCH_CONFIG_DATA_START:
      return {
        ...state,
        loading: true,
        error: null
      };

    case types.FETCH_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload
      };

    case types.FETCH_CONFIG_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // ================================COLLEGE COURSE MAPPING - ASYNC ================================ //
    case types.CREATE_COLLEGE_COURSE_MAPPING_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          creating: true,
          createError: null
        }
      };

    case types.CREATE_COLLEGE_COURSE_MAPPING_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          creating: false
        },
        mappings: {
          ...state.mappings,
          collegeCourses: [...state.mappings.collegeCourses, action.payload]
        }
      };

    case types.CREATE_COLLEGE_COURSE_MAPPING_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          creating: false,
          createError: action.payload
        }
      };

    case types.UPDATE_COLLEGE_COURSE_MAPPING_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          updating: false
        },
        mappings: {
          ...state.mappings,
          collegeCourses: state.mappings.collegeCourses.map(mapping =>
            mapping.id === action.payload.id ? action.payload : mapping
          )
        }
      };

    case types.DELETE_COLLEGE_COURSE_MAPPING_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          deleting: false
        },
        mappings: {
          ...state.mappings,
          collegeCourses: state.mappings.collegeCourses.filter(mapping =>
            mapping.id !== action.payload
          )
        }
      };

    case types.FETCH_COLLEGE_COURSE_MAPPINGS_SUCCESS:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeCourses: action.payload.data
        },
        pagination: {
          ...state.pagination,
          collegeCourses: action.payload.pagination
        }
      };

    case types.REFRESH_COLLEGE_COURSE_MAPPINGS:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeCourses: action.payload
        }
      };

       case types.FETCH_COLLEGE_DEGREES_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          fetchingCollegeDegrees: true,
          collegDegreesError: null
        }
      };

    case types.FETCH_COLLEGE_DEGREES_SUCCESS:
      // Flatten the nested degree_configurations structure from API response
      const flattenedDegrees = action.payload?.map(item => item.degree_configurations || item) || [];
      return {
        ...state,
        collegeDegrees: flattenedDegrees,
        operations: {
          ...state.operations,
          fetchingCollegeDegrees: false,
          collegDegreesError: null
        }
      };

    case types.FETCH_COLLEGE_DEGREES_FAILURE:
      return {
        ...state,
        collegeDegrees: [],
        operations: {
          ...state.operations,
          fetchingCollegeDegrees: false,
          collegDegreesError: action.payload
        }
      };

    case types.CLEAR_COLLEGE_DEGREES:
      return {
        ...state,
        collegeDegrees: [],
        operations: {
          ...state.operations,
          fetchingCollegeDegrees: false,
          collegDegreesError: null
        }
      };
    // ================================SME COURSE MAPPING - ASYNC ================================ //
    case types.CREATE_SME_COURSE_MAPPING_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          creating: true,
          createError: null
        }
      };

    case types.CREATE_SME_COURSE_MAPPING_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          creating: false
        },
        mappings: {
          ...state.mappings,
          smeCourses: [...state.mappings.smeCourses, action.payload]
        }
      };

    case types.DELETE_SME_COURSE_MAPPING_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          deleting: false
        },
        mappings: {
          ...state.mappings,
          smeCourses: state.mappings.smeCourses.filter(mapping =>
            mapping.id !== action.payload
          )
        }
      };

    case types.FETCH_SME_COURSE_MAPPINGS_SUCCESS:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          smeCourses: action.payload.data
        },
        pagination: {
          ...state.pagination,
          smeCourses: action.payload.pagination
        }
      };

    // ================================DEGREE CONFIGURATION - ASYNC ================================ //
    case types.CREATE_DEGREE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          creating: false
        },
        degrees: [...state.degrees, action.payload]
      };

    case types.UPDATE_DEGREE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          updating: false
        },
        degrees: state.degrees.map(degree =>
          degree.id === action.payload.id ? action.payload : degree
        )
      };

    case types.DELETE_DEGREE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          deleting: false
        },
        degrees: state.degrees.filter(degree => degree.id !== action.payload)
      };

      case types.FETCH_DEGREE_CONFIGURATIONS_SUCCESS:
        return {
            ...state,
            degrees: action.payload.data,
            pagination: {
                ...state.pagination,
                degreeCourses: action.payload.pagination
            }
        };

    // ================================LEGACY SYNC ACTIONS ================================ //
    case types.ADD_COLLEGE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeCourses: [...state.mappings.collegeCourses, action.payload]
        }
      };

    case types.UPDATE_COLLEGE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeCourses: state.mappings.collegeCourses.map(mapping =>
            mapping.id === action.payload.id ? action.payload : mapping
          )
        }
      };

    case types.DELETE_COLLEGE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeCourses: state.mappings.collegeCourses.filter(mapping =>
            mapping.id !== action.payload
          )
        }
      };

    case types.ADD_SME_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          smeCourses: [...state.mappings.smeCourses, action.payload]
        }
      };

    case types.UPDATE_SME_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          smeCourses: state.mappings.smeCourses.map(mapping =>
            mapping.id === action.payload.id ? action.payload : mapping
          )
        }
      };

    case types.DELETE_SME_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          smeCourses: state.mappings.smeCourses.filter(mapping =>
            mapping.id !== action.payload
          )
        }
      };

    case types.ADD_DEGREE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          degreeCourses: [...state.mappings.degreeCourses, action.payload]
        }
      };

    case types.UPDATE_DEGREE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          degreeCourses: state.mappings.degreeCourses.map(mapping =>
            mapping.id === action.payload.id ? action.payload : mapping
          )
        }
      };

    case types.DELETE_DEGREE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          degreeCourses: state.mappings.degreeCourses.filter(mapping =>
            mapping.id !== action.payload
          )
        }
      };

    case types.ADD_LANGUAGE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          languageCourses: [...state.mappings.languageCourses, action.payload]
        }
      };

    case types.UPDATE_LANGUAGE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          languageCourses: state.mappings.languageCourses.map(mapping =>
            mapping.id === action.payload.id ? action.payload : mapping
          )
        }
      };

    case types.DELETE_LANGUAGE_COURSE_MAPPING:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          languageCourses: state.mappings.languageCourses.filter(mapping =>
            mapping.id !== action.payload
          )
        }
      };
     
        // ================================COLLEGE DEGREE MAPPING - NEW (Under mappings) ================================ //
    case types.FETCH_COLLEGE_DEGREE_MAPPINGS_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          fetchingCollegeDegreeMappings: true,
          collegeDegreeMappingError: null
        }
      };

    case types.FETCH_COLLEGE_DEGREE_MAPPINGS_SUCCESS:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeDegreeMappings: action.payload.data || [] // NEW: Under mappings
        },
        pagination: {
          ...state.pagination,
          collegeDegreeMappings: action.payload.pagination || state.pagination.collegeDegreeMappings
        },
        operations: {
          ...state.operations,
          fetchingCollegeDegreeMappings: false,
          collegeDegreeMappingError: null
        }
      };

    case types.FETCH_COLLEGE_DEGREE_MAPPINGS_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          fetchingCollegeDegreeMappings: false,
          collegeDegreeMappingError: action.payload
        }
      };

    case types.CREATE_COLLEGE_DEGREE_MAPPING_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          creatingCollegeDegreeMapping: true,
          collegeDegreeMappingError: null
        }
      };

    case types.CREATE_COLLEGE_DEGREE_MAPPING_SUCCESS:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeDegreeMappings: [...state.mappings.collegeDegreeMappings, action.payload] // NEW: Under mappings
        },
        operations: {
          ...state.operations,
          creatingCollegeDegreeMapping: false,
          collegeDegreeMappingError: null
        }
      };

    case types.CREATE_COLLEGE_DEGREE_MAPPING_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          creatingCollegeDegreeMapping: false,
          collegeDegreeMappingError: action.payload
        }
      };

    case types.UPDATE_COLLEGE_DEGREE_MAPPING_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          updatingCollegeDegreeMapping: true,
          collegeDegreeMappingError: null
        }
      };

    case types.UPDATE_COLLEGE_DEGREE_MAPPING_SUCCESS:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeDegreeMappings: state.mappings.collegeDegreeMappings.map(mapping =>
            mapping.id === action.payload.id ? action.payload : mapping
          ) // NEW: Under mappings
        },
        operations: {
          ...state.operations,
          updatingCollegeDegreeMapping: false,
          collegeDegreeMappingError: null
        }
      };

    case types.UPDATE_COLLEGE_DEGREE_MAPPING_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          updatingCollegeDegreeMapping: false,
          collegeDegreeMappingError: action.payload
        }
      };

    case types.DELETE_COLLEGE_DEGREE_MAPPING_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          deletingCollegeDegreeMapping: true,
          collegeDegreeMappingError: null
        }
      };

    case types.DELETE_COLLEGE_DEGREE_MAPPING_SUCCESS:
      return {
        ...state,
        mappings: {
          ...state.mappings,
          collegeDegreeMappings: state.mappings.collegeDegreeMappings.filter(
            mapping => mapping.id !== action.payload
          ) // NEW: Under mappings
        },
        operations: {
          ...state.operations,
          deletingCollegeDegreeMapping: false,
          collegeDegreeMappingError: null
        }
      };

    case types.DELETE_COLLEGE_DEGREE_MAPPING_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          deletingCollegeDegreeMapping: false,
          collegeDegreeMappingError: action.payload
        }
      };

    // ================================UI STATE ================================ //
    case types.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
        operations: {
          ...state.operations,
          createError: null,
          updateError: null,
          deleteError: null
        }
      };

    // ================================SEMESTER PROMOTION ================================ //
    case types.PROMOTE_SEMESTER_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          promotingSemester: true,
          promotionResult: null,
          promotionError: null
        }
      };

    case types.PROMOTE_SEMESTER_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          promotingSemester: false,
          promotionResult: action.payload,
          promotionError: null
        }
      };

    case types.PROMOTE_SEMESTER_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          promotingSemester: false,
          promotionResult: null,
          promotionError: action.payload
        }
      };

    case types.CLEAR_PROMOTION_RESULT:
      return {
        ...state,
        operations: {
          ...state.operations,
          promotionResult: null,
          promotionError: null
        }
      };

    // ================================SEMESTER PREVIEW ================================ //
    case types.PREVIEW_SEMESTER_START:
      return {
        ...state,
        operations: {
          ...state.operations,
          previewingSemester: true,
          semesterPreview: null,
          previewError: null
        }
      };

    case types.PREVIEW_SEMESTER_SUCCESS:
      return {
        ...state,
        operations: {
          ...state.operations,
          previewingSemester: false,
          semesterPreview: action.payload,
          previewError: null
        }
      };

    case types.PREVIEW_SEMESTER_FAILURE:
      return {
        ...state,
        operations: {
          ...state.operations,
          previewingSemester: false,
          semesterPreview: null,
          previewError: action.payload
        }
      };

    case types.CLEAR_SEMESTER_PREVIEW:
      return {
        ...state,
        operations: {
          ...state.operations,
          previewingSemester: false,
          semesterPreview: null,
          previewError: null
        }
      };

    default:
      return state;
  }
};

export default adminConfigReducer;
